
















































import Vue from "vue";

// Model
import { CashTypeEnum, cashTypeEnumLabel } from "@/model/data/enums/CashTypeEnum";
import { GetBranchReportReqData } from "@/model/communication/branchReport/GetBranchReportReqData";
import DateTimeRangePicker from "@/components/DateTimeRangePicker.vue";
const selectedCurrency = "CLINK_selected_currency_branch_report";

export default Vue.extend({
    data() {
        return {
            CashTypeEnum,

            filters: {
                startDate: null,
                endDate: null,
                branchName: null,
                currency: null,
                cashType: null,
            },
            selectedBranchName: "",
        };
    },
    components: {
        DateTimeRangePicker,
    },
    props: {
        loading: Boolean,
        value: {},
        availableBranchNames: Array,
        availableCurrencies: Array,
    },
    computed: {
        selectedCurrency: {
            get() {
                return (this.filters as GetBranchReportReqData).currency;
            },
            set(newValue: string) {
                (this.filters as GetBranchReportReqData).currency = newValue;
                this.$emit("input", this.filters);
            },
        },
    },
    watch: {
        availableBranchNames: {
            handler(newVal) {
                if (newVal && newVal.length) this.selectedBranchName = newVal[0];
            },
            deep: true,
            immediate: true,
        },
        value: {
            handler(newVal) {
                if (newVal && newVal.branchName && newVal.branchName != this.selectedBranchName.value) this.selectedBranchName = newVal.branchName;
                if (newVal && newVal.currency) localStorage.setItem(selectedCurrency, newVal.currency);
            },
            deep: true,
        },
    },
    mounted() {
        this.filters = this.value;
    },
    methods: {
        cashTypeEnumLabel,
        handleInput(value) {
            this.$emit("input", value);
        },
        changedBranch(newValue) {
            (this.filters as GetBranchReportReqData).branchName = newValue.value;
            this.$emit("input", this.filters);
        },
    },
});
